export const SEMESTER_LIST = [
  { label: 'เทอม 1 ปีการศึกษา 2564', value: 'semester1' },
  { label: 'เทอม 2 ปีการศึกษา 2564', value: 'semester2' },
  { label: 'เทอม 1 ปีการศึกษา 2565', value: 'semester3' },
];
